/**
 * Defines the filter levels for customer monthly statistics.
 */
export enum CustomerMonthlyStatisticFilterLevelModel {
	/**
	 * Represents the normal filter level.
	 */
	Normal = 1,
	/**
	 * Represents the medium filter level.
	 */
	Medium = 2,
	/**
	 * Represents the high filter level.
	 */
	High = 3,
	/**
	 * Represents the critical filter level.
	 */
	Critical = 4
}
